import React, { useEffect } from "react";
import business1 from "../../assets/business01_1.png";
import business2 from "../../assets/business01_2.jpg";
import business3 from "../../assets/business01_3.png";
import business4 from "../../assets/business01_4.png";
import AOS from "aos";
import "aos/dist/aos.css";
import line from "../../assets/line.png";

function Busi_si() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div className="Busi_si">
        <div id="sub" className="mission">
          <div className="cont-wr">
            <div className="wr">
              <div className="cont-tit">
                <h2 className="big">시스템개발(System Integration)</h2>
                <div className="cont-tit">
                  <h2>"고객과 함께 성장하는 IT 서비스 구축 업무 수행합니다"</h2>
                </div>
                <div className="wr">
                  <p className="des">
                    SI 기획에서부터 종료까지 프로젝트를 관리할 수 있는 새로운
                    관리 방법론과 개발 방법론을 수립하고 프로젝트를 효과적으로
                    수행할 <br className="pc-only" />수 있는 PM Guide를 개발하여
                    고객에게 보다 안정적이고 차별화된 시스템을 제공하고
                    있습니다. <br className="pc-only" />
                    20여 년간 농림축산분야의 정보시스템의 개발 및 운영을 통해
                    축적된 노하우와 현장의 프로젝트 관리 경험이 최적화되고
                    내재화 됨으로써 <br className="pc-only" />
                    프로젝트 유형별로 기획, 착수, 개발과정에서 나타날 수 있는
                    이슈에 대한 사전 예방과 체계적인 처방을 제시하고 있습니다.{" "}
                    <br className="pc-only" />
                    농림축산업 전 분야의 대형 프로젝트 구축 경험뿐 아니라,
                    독자적인 개발 프레임워크와 개발 방법론으로
                    <br className="pc-only" />
                    고객의 비즈니스 환경 및 요구사항에 적합한 최적의 시스템을
                    구현합니다.
                  </p>
                  <div className="center">
                    <div className="img center">
                      <img src={business1} alt="" />
                      <img
                        src={business2}
                        alt=""
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-duration="500"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="cont-wr">
              <div className="wr">
                <div
                  className="img center"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                >
                  <div
                    className="img center"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                  ></div>
                  <div className="cont-tit">
                    <div className="img center">
                      <img src={line} alt="" />
                    </div>
                    <h2 className="big">시스템운영(System Management)</h2>
                    <div className="cont-tit">
                      <h2>"프리미엄 서비스로 고객의 혁신을 리딩 합니다!"</h2>
                    </div>
                    <div className="wr">
                      <p className="des">
                        시스템 운영은 고객의 정보 시스템을 지속 관리하고
                        운영하는 것으로, HW, SW, 어플리케이션, 네트워크, 인프라
                        등을 <br className="pc-only" />
                        개발 운용 유지 보수하고 이를 향상시키는 것을 말합니다.{" "}
                        <br className="pc-only" />
                        제닉스는 고객사 환경에 맞는 고품질의 운영 서비스를
                        제공함을 최우선으로 생각합니다.
                      </p>
                      <div className="center">
                        <img src={business3} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="cont-wr">
              <div className="wr">
                <div
                  className="img center"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                >
                  <div className="cont-tit">
                    <div className="img center">
                      <img src={line} alt="" />
                    </div>
                    <h2 className="big">R&D(연구개발)</h2>
                    <div className="cont-tit">
                      <h2>"농림 정보화 관련 R&D(연구개발) 수행"</h2>
                    </div>
                    <div className="wr">
                      <p className="des">
                        농업의 지속가능성을 위해 빅데이터 분석과 농업 시스템의
                        디지털화를 통해 농업 디지털 전환을 선도하고 있습니다.{" "}
                        <br className="pc-only" />
                        공공기관 및 농민들의 요구사항을 적극 수렴하여 농업 전산
                        자동화, 블록체인 기반 유통 추적관리 자동화 등을 구현하고{" "}
                        <br className="pc-only" />
                        이를 지속적으로 고도화하여 농업인의 부담을 덜어주고
                        소비자의 만족도를 높이기 위한 노력을 이어가고 있습니다.{" "}
                      </p>
                      <div className="center">
                        <img src={business4} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Busi_si;
